// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface JiraIconSignature {
  Element: SVGSVGElement;
}

export const JiraIcon: TOC<JiraIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.6074 1.00106L22.9347 11.3284C23.3053 11.6995 23.3053 12.3005 22.9347 12.6716L19.5007 16.1056L19.3804 16.226L11.6063 24L7.38037 19.774L0.277939 12.6716C-0.0926463 12.3005 -0.0926463 11.6995 0.277939 11.3284L3.83232 7.77402L11.6063 0L12.6074 1.00106ZM8.0583 12L11.6063 15.548L15.1544 12L11.6063 8.45195L8.0583 12Z"/>
</svg>
</template>;